module.exports = "//static.hsappstatic.net/visitor-ui-component-library/static-1.4089/img/default-avatar.png"